import { Block, Flex, Typography } from '@aloft/toolkit-sui';

export const CertifyModalAcknowledgment = () => (
  <Flex flexDirection="column" gap="2px">
    <Typography variant="body2" color="textSecondary">
      I certify that, to the best of my knowledge and belief:
    </Typography>
    <Flex alignItems="center" gap=".25rem">
      <Block
        height=".25rem"
        width=".25rem"
        borderRadius="50%"
        backgroundColor="textSecondary"
        marginLeft="5px"
        marginRight="5px"
      />
      <Typography variant="body2" color="textSecondary">
        The statements in this report are true and correct
      </Typography>
    </Flex>
    <Flex alignItems="center" gap=".25rem">
      <Block
        height=".25rem"
        width=".25rem"
        borderRadius="50%"
        backgroundColor="textSecondary"
        marginLeft="5px"
        marginRight="5px"
      />
      <Typography variant="body2" color="textSecondary">
        My opinions, conclusions, and analyses are impartial and unbiased.
      </Typography>
    </Flex>
    <Flex alignItems="center" gap=".25rem">
      <Block
        height=".25rem"
        width=".25rem"
        borderRadius="50%"
        backgroundColor="textSecondary"
        marginLeft="5px"
        marginRight="5px"
      />
      <Typography variant="body2" color="textSecondary">
        I have no present or prospective interest in the subject property and no bias regarding any
        involved parties.
      </Typography>
    </Flex>
    <Flex alignItems="center" gap=".25rem">
      <Block
        height=".25rem"
        width=".25rem"
        borderRadius="50%"
        backgroundColor="textSecondary"
        marginLeft="5px"
        marginRight="5px"
      />
      <Typography variant="body2" color="textSecondary">
        My compensation is not contingent upon the appraisal results.
      </Typography>
    </Flex>
    <Flex alignItems="center" gap=".25rem">
      <Block
        height=".25rem"
        width=".25rem"
        borderRadius="50%"
        backgroundColor="textSecondary"
        marginLeft="5px"
        marginRight="5px"
      />
      <Typography variant="body2" color="textSecondary">
        Unless otherwise noted, I did not inspect the subject property.
      </Typography>
    </Flex>
    <Flex alignItems="center" gap=".25rem">
      <Block
        height=".25rem"
        width=".25rem"
        borderRadius="50%"
        backgroundColor="textSecondary"
        marginLeft="5px"
        marginRight="5px"
      />
      <Typography variant="body2" color="textSecondary">
        My analysis conforms with USPAP standards.
      </Typography>
    </Flex>
    <Flex alignItems="center" gap=".25rem">
      <Block
        height=".25rem"
        width=".25rem"
        borderRadius="50%"
        backgroundColor="textSecondary"
        marginLeft="5px"
        marginRight="5px"
      />
      <Typography variant="body2" color="textSecondary">
        No significant appraisal assistance was provided by others unless disclosed.
      </Typography>
    </Flex>
    <Flex alignItems="center" gap=".25rem">
      <Block
        height=".25rem"
        width=".25rem"
        borderRadius="50%"
        backgroundColor="textSecondary"
        marginLeft="5px"
        marginRight="5px"
      />
      <Typography variant="body2" color="textSecondary">
        I have not performed services related to this property in the prior three years unless
        stated otherwise.
      </Typography>
    </Flex>
    <Flex alignItems="center" gap=".25rem">
      <Block
        height=".25rem"
        width=".25rem"
        borderRadius="50%"
        backgroundColor="textSecondary"
        marginLeft="5px"
        marginRight="5px"
      />
      <Typography variant="body2" color="textSecondary">
        The estimated exposure time aligns with the Market Time found in the Neighborhood
        Characteristics section.
      </Typography>
    </Flex>
  </Flex>
);
